import { useId } from 'react';

type DeviaqMarkProps = {
  size?: number;
  /** När märket visas ensamt (ihopfälld sidomeny) ska det ha ett tillgängligt namn. */
  labelled?: boolean;
  className?: string;
};

/** Teal båge med ljus kärna — DeviaQ-märket. */
export function DeviaqMark({ size = 48, labelled = false, className }: DeviaqMarkProps) {
  const rawId = useId().replace(/:/g, '');
  const glowId = `deviaq-glow-${rawId}`;
  const arcId = `deviaq-arc-${rawId}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role={labelled ? 'img' : undefined}
      aria-label={labelled ? 'DeviaQ' : undefined}
      aria-hidden={labelled ? undefined : true}
    >
      <defs>
        <radialGradient id={glowId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#E8FFF8" />
          <stop offset="42%" stopColor="#7AF0D6" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#2AD4B4" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={arcId} x1="18%" y1="8%" x2="82%" y2="92%">
          <stop offset="0%" stopColor="#7DFFE6" />
          <stop offset="55%" stopColor="#1ED9B8" />
          <stop offset="100%" stopColor="#0EBEA0" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="15" fill={`url(#${glowId})`} />
      <path
        d="M46.2 18.4 A18.6 18.6 0 1 0 48.8 40.6"
        fill="none"
        stroke={`url(#${arcId})`}
        strokeWidth="6.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

type DeviaqDefaultLogoProps = {
  collapsed?: boolean;
};

/** Standardlogotyp när kunden inte har en egen. */
export function DeviaqDefaultLogo({ collapsed = false }: DeviaqDefaultLogoProps) {
  return (
    <>
      <DeviaqMark size={collapsed ? 40 : 48} labelled={collapsed} />
      {!collapsed && (
        <span className="mt-2 text-sm font-semibold text-textDefault">DeviaQ</span>
      )}
    </>
  );
}
